import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, of, switchMap } from 'rxjs';

import { EffectsBase } from '@ps/core-data-access';

import { TagsService } from '../services/tags.service';
import { TagsActions, TagsApiActions } from './tags.actions';

@Injectable()
export class TagsEffects extends EffectsBase {
  private readonly _actions$ = inject(Actions);
  private readonly _tagsService = inject(TagsService);

  public readonly loadTags$ = createEffect(() =>
    this._actions$.pipe(
      ofType(TagsActions.loadTags),
      switchMap(() =>
        this._tagsService.getTags().pipe(
          map((tags) => TagsApiActions.loadTagsSuccess({ tags })),
          this.psCatchError((error) =>
            of(TagsApiActions.loadTagsFailure({ error: error.message })),
          ),
        ),
      ),
    ),
  );

  public readonly createTag$ = createEffect(() =>
    this._actions$.pipe(
      ofType(TagsActions.createTag),
      exhaustMap(({ request }) =>
        this._tagsService.createTag(request).pipe(
          map((tag) => TagsApiActions.createTagSuccess({ tag })),
          this.psCatchError((error) =>
            of(TagsApiActions.createTagFailure({ error: error.message })),
          ),
        ),
      ),
    ),
  );
}
